'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _module = angular.module('cb.strips.cbStripSubnavigatieV1', []);

_module.directive('cbStripSubnavigatieV1', cbStripSubnavigatieV1);

exports.default = _module;


function cbStripSubnavigatieV1() {
    return {
        restrict: 'A',
        scope: {},
        link: cbStripSubnavigatieV1Link
    };

    function cbStripSubnavigatieV1Link($log) {
        var version = 1.00;

        var strip = document.querySelector('.strip.strip-subnavigatie');

        var items = strip.getElementsByClassName('nav-bar__item');

        if (!strip) {
            $log.error('Error: element not found.');
            return;
        }

        activate();

        function activate() {
            // Check if 'sticky' attribute is set
            var sticky = strip.getAttribute('data-sticky');
            var stickyEnabled = sticky !== null && sticky !== 'false';

            if (stickyEnabled) {
                strip.classList.add('strip-subnavigatie--sticky');

                // Check if header is fixed to calculate offset from top (prevent from overflow)
                if (isFixedHeader()) {
                    strip.classList.add('is-header');
                }
            }

            // Check if 'one-page' attribute is set
            var onePage = strip.getAttribute('data-one-page');
            var onePageEnabled = onePage !== null && onePage !== 'false';

            if (onePageEnabled) {
                // Add select function to each nav-bar item (for one page navigation)
                for (var i = 0; i < items.length; i++) {
                    items[i].addEventListener('click', selectNavBarItem);
                }
            }

            scrollToActiveElement();
        }

        // Scroll to current selected element (on small devices)
        function scrollToActiveElement() {
            var navbar = strip.querySelector('.nav-bar');
            var elm = navbar.querySelector('.active');

            if (elm) {
                navbar.scrollLeft = navbar.offsetWidth - elm.offsetWidth;
            }
        }

        // Check if header element has fixed position
        function isFixedHeader() {
            var header = document.querySelector('header');
            var retVal = false;

            if (header) {
                retVal = window.getComputedStyle(header).getPropertyValue('position').toLowerCase() === 'fixed';
            }

            return retVal;
        }

        function selectNavBarItem() {
            for (var i = 0; i < items.length; i++) {
                items[i].classList.remove('active');
            }

            this.classList.add('active');
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/strips/subnavigatie-v1/subnavigatie.directive.js
// module id = 959
// module chunks = 1